import React, {useState} from 'react'
import PropTypes from 'prop-types'
import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'
import {routeKeys} from '#config/routeKeys'
import Headline from '#components/a/Headline'
import PrintButtonTooltip from '#components/m/PrintButtonTooltip'
import ControlsGroup from '#components/m/ControlsGroup'
import {LinkWithArrow} from '#components/m/MeineOrganisation/LinkWithArrow'
import ErrorModal from '#components/m/ErrorModal'

function NachweisListeAzubiHeader({
  maxNachweisNumber,
  showLinkToOtherAusbildungsnachweise,
  showArchivedAusbildungsnachweise,
}) {
  const headline = showArchivedAusbildungsnachweise
    ? 'ausbildungsnachweiseOverview_old_nachweise'
    : 'ausbildungsnachweiseOverview_headline'
  const linkText = showArchivedAusbildungsnachweise
    ? 'ausbildungsnachweiseOverview_headline'
    : 'ausbildungsnachweiseOverview_old_nachweise'
  const linkRoute = showArchivedAusbildungsnachweise
    ? routeKeys.ausbildungsnachweise
    : routeKeys.alteAusbildungsnachweise

  const [error, setError] = useState()

  const handlePrintAsAzubi = async (min, max, printCover) => {
    try {
      return await Api.printNachweisRangeAzubi(min, max, printCover, !!showArchivedAusbildungsnachweise)
    } catch (e) {
      if (e && e.message) {
        const translatedMessage = i18n.t(e.message)
        if (translatedMessage !== e.message) {
          e.message = translatedMessage
        }
        setError(e)
      } else {
        actions.error.writeError({error: e})
        throw new Error(e.message)
      }
    }
  }

  return (
    <div className="nachweisliste__header">
      {error && error.message && (
        <ErrorModal
          headline={i18n.t('ausbildungsnachweis_print_error')}
          text={error.message}
          error={error}
          showModal={true}
          buttonText={i18n.t('okay')}
          onButtonClick={() => {
            setError(null)
          }}
        />
      )}
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <Headline importance={1} modifier="section" text={i18n.t(headline)} />

          {showLinkToOtherAusbildungsnachweise && <LinkWithArrow to={linkRoute} text={i18n.t(linkText)} />}
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <ControlsGroup modifier="wrapper">
            {maxNachweisNumber !== 0 && (
              <ControlsGroup modifier="secondary">
                <PrintButtonTooltip
                  maxNachweisNummer={maxNachweisNumber}
                  minNachweisNummer={1}
                  handlePrint={handlePrintAsAzubi}
                />
              </ControlsGroup>
            )}
          </ControlsGroup>
        </div>
      </div>
    </div>
  )
}

NachweisListeAzubiHeader.propTypes = {
  maxNachweisNumber: PropTypes.number,
  showLinkToOtherAusbildungsnachweise: PropTypes.bool,
  showArchivedAusbildungsnachweise: PropTypes.bool,
}

export default NachweisListeAzubiHeader
